import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Markdown`}</h1>
    <p>{`En su sintaxis soporta:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Notas`}</p>
    </blockquote>
    <p>{`Enlaces `}<a parentName="p" {...{
        "href": "http://www.secorto.com"
      }}>{`secorto.com`}</a></p>
    <p>{`Imagenes`}</p>
    <img {...{
      "src": "https://www.secorto.com/img/logo.png",
      "alt": "Logo"
    }}></img>
    <p>{`entre otros elementos que puedes consultar en
`}<a parentName="p" {...{
        "href": "https://www.markdownguide.org/cheat-sheet/"
      }}>{`Markdown cheatset`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      